'use strict';
angular.module('clientDashboardApp').directive('loadingWrapper',function(){

  return {
    restrict: "E",
    template: require("./loadingWrapper.html"),
    scope: {
      pageStrings : "=",
      state: "="
    }
  }

});
